import { render } from "./managementCenterView.vue?vue&type=template&id=e6c91074&scoped=true&ts=true"
import script from "./managementCenterView.vue?vue&type=script&lang=ts"
export * from "./managementCenterView.vue?vue&type=script&lang=ts"

import "./managementCenterView.vue?vue&type=style&index=0&id=e6c91074&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c91074"]])

export default __exports__